import React from 'react';

function ViewAttendance() {
  return <div>ViewAttendance</div>;
}

export default ViewAttendance;
